
import {forwardRef } from "react";

// @mui material components
import InputRoot from "./InputRoot";

// Custom styles for MDInput


const WDInput = forwardRef(({ error, success, disabled, ...rest }, ref) => (
  <InputRoot {...rest} ref={ref} ownerState={{ error, success, disabled }} />
));

// Declaring default props for MDInput
WDInput.defaultProps = {
  error: false,
  success: false,
  disabled: false,
};

export default WDInput;
